/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddUserLoginInformationCommand } from '../../models/add-user-login-information-command';
import { SuccessApiResponse } from '../../models/success-api-response';

export interface AddUserLoginInformationAsync$Params {
      body?: AddUserLoginInformationCommand
}

export function addUserLoginInformationAsync(http: HttpClient, rootUrl: string, params?: AddUserLoginInformationAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, addUserLoginInformationAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

addUserLoginInformationAsync.PATH = '/api/user/login-information';
